import { redirect } from '@tanstack/react-router'

import { authEvents } from '@/core/lib/auth-events'
import { notify } from '@/core/lib/ui-bus'
import type { TPermissionKey } from '@/core/types/permission'
import { getAuth, hasPermission } from '@/core/utils/auth-utils'

export type GuardCtx = { location: { href: string } }

// Kimlik doğrulanmamışsa girişe yönlendir (geri dönüş için redirectTo taşı).
export const requireAuth = async ({ location }: GuardCtx) => {
  const auth = await getAuth()
  if (!auth?.email) {
    throw redirect({
      to: '/',
      search: { status: 'requested', redirectTo: location.href },
    })
  }
  return auth
}

// Zaten girişliyse panele yönlendir (giriş sayfası gibi public rotalar için).
export const requirePublic = async () => {
  const auth = await getAuth()
  if (auth?.email) {
    throw redirect({ to: '/app' })
  }
}

// Kimlik + izin: izin yoksa forbidden olayını yayınla ve forbidden sayfasına yönlendir.
export const requirePermission =
  (permission: TPermissionKey) => async (ctx: GuardCtx) => {
    await requireAuth(ctx)
    const ok = await hasPermission(permission)
    if (!ok) {
      authEvents.emit('forbidden')
      throw redirect({ to: '/app/forbidden' })
    }
  }

// Route `beforeLoad` içinde izin kontrolü. Preload sırasında da kontrol edilir;
// yetkisiz route verisi cache'e alınmasın diye yalnız bildirim basılmaz.
export const routeHasPermission = async (
  preload: boolean,
  permission: TPermissionKey,
  message: string
) => {
  const canAccess = await hasPermission(permission)
  if (!canAccess) {
    if (!preload) {
      notify.error({ message: 'Yetkilendirme Hatası', description: message })
    }
    throw redirect({ to: '/app/forbidden' })
  }
}
